import { render } from "./LitterRegistration.vue?vue&type=template&id=6bb083e1&scoped=true"
import script from "./LitterRegistration.vue?vue&type=script&lang=js"
export * from "./LitterRegistration.vue?vue&type=script&lang=js"

import "./LitterRegistration.vue?vue&type=style&index=0&id=6bb083e1&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb083e1"]])

export default __exports__